var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no_auth_tip",class:{hidden: _vm.hide}},[_c('div',[_vm._v("网络请求异常，请重新登陆")]),_vm._v(" "),_c('div',[_vm._v("将在"),_c('span',{staticClass:"seconds"},[_vm._v(_vm._s(_vm.num)+"秒")]),_vm._v("后返回首页！")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-566d4aa2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/logout/index.vue
// module id = null
// module chunks = 